import script from "./ForecastDiffLastMonthTableCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForecastDiffLastMonthTableCell.vue?vue&type=script&lang=ts&setup=true"

import "./ForecastDiffLastMonthTableCell.vue?vue&type=style&index=0&id=35f8be4a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f8be4a"]])

export default __exports__